module.exports = __webpack_public_path__ + "img/ChimeLayer.7634ff59.svg";